var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"blue-color"},[_vm._v(_vm._s(_vm.$t('views.navbar.diagnose')))])]),_vm._v(" "),_c('div',{staticClass:"card-content grey lighten-4"},[_vm._v("\n      Diagnose\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f400d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/application/diagnose.vue
// module id = null
// module chunks = 